module.exports = __webpack_public_path__ + "static/media/13 REGGIANA CALCIO Stadio Città del Tricolore.55aca9bb.svg";